import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
      errorInfo: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });

    console.error(
      error,
      errorInfo.componentStack,
      // React.captureOwnerStack(),
    );
  }

  resetError = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    const { hasError, error, errorInfo } = this.state;

    if (hasError && error) {
      return this.props.fallback(this.resetError, error, errorInfo ?? undefined);
    }

    return this.props.children;
  }
}

export default ErrorBoundary;